var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['plateBlock', _vm.customClass],attrs:{"id":_vm.id}},[_c('ul',_vm._l((_vm.data),function(item,index){return _c('li',{key:index,staticClass:"plate_item"},[_c('div',{class:_vm.getClass(item.fBuyValue)},[_c('div',[_vm._v(_vm._s(item.sPlate))]),_c('div',{staticClass:"num"},[_vm._v(_vm._s(item.sBuyValue))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }